import { render } from "./gmAbnormalNumber.vue?vue&type=template&id=967a3526&scoped=true"
import script from "./gmAbnormalNumber.vue?vue&type=script&lang=js"
export * from "./gmAbnormalNumber.vue?vue&type=script&lang=js"

import "./gmAbnormalNumber.vue?vue&type=style&index=0&id=967a3526&scoped=true&lang=css"
import "./gmAbnormalNumber.vue?vue&type=style&index=1&id=967a3526&lang=css"
script.render = render
script.__scopeId = "data-v-967a3526"

export default script